import React from 'react';

const PersistentTabPanel = ({ children, value, index, ...other }) => {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      style={{ display: value === index ? 'block' : 'none' }}
      {...other}
    >
      {children}
    </div>
  );
};

export default PersistentTabPanel;
